export default "__VITE_ASSET__CqhajRaL__"